// httpPorts — the Brief slice: plan a document, revise its brief, generate
// from it, and a container's export readiness, over the command bus. Every
// reply is parsed at this boundary.

import { Result } from "@bilda/utils";
import { mkMalformed } from "../externalError.js";
import { parseGenerationSnapshot } from "../generationAdapter.js";
import type { BriefPorts } from "../ports/brief.js";
import { parseExportReadiness } from "../readinessAdapter.js";
import { fields, str } from "../wireShape.js";
import { command } from "./shared.js";

export const briefHttp: BriefPorts = {
    planDocument: async (containerId, title, brief, kind) => {
        const r = await command("planDocument", {
            container: containerId,
            title,
            brief,
            ...(kind === undefined ? {} : { kind }),
        });
        if (Result.isErr(r)) return r;
        const documentId = str(fields(r.value)?.get("document"));
        return documentId === undefined
            ? Result.err(mkMalformed("planDocument returned no document id"))
            : Result.ok({ containerId, documentId });
    },
    reviseBrief: async (resourceId, brief) => {
        const r = await command("reviseBrief", { resourceId, brief });
        return Result.isErr(r) ? r : Result.ok({ resourceId });
    },
    generateFromBrief: async (resourceId) => {
        const r = await command("generateFromBrief", { resourceId });
        return Result.isErr(r) ? r : parseGenerationSnapshot(r.value);
    },
    loadExportReadiness: async (containerId) => {
        const r = await command("exportReadiness", { containerId });
        return Result.isErr(r) ? r : parseExportReadiness(r.value);
    },
};
